/**
 * Resolve block ends and recognize cursors before schema placeholder suffixes.
 */

import { Node as EditorNode, ResolvedPos } from 'prosemirror-model'
import {
  TextSelection as OriginalTextSelection,
  Selection,
} from 'prosemirror-state'

import { getLogicalEndSuffix } from '#util/prosemirrorHelpers/wrapped-block-helpers'

export class TextSelection extends OriginalTextSelection {
  /**
   * Find a valid cursor at the last text position of the block at or
   * containing `pos`, snapping to the nearest text position if needed
   */
  static nearEndOfBlock(node: EditorNode, pos: number): TextSelection {
    const $end = resolveBlockEnd(node, pos)
    const selection =
      OriginalTextSelection.findFrom($end, -1, true) ?? Selection.near($end, -1)
    return new TextSelection(selection.$from, selection.$to)
  }
}

/**
 * Whether a cursor is at its textblock's end, ignoring trailing whitespace
 * and the closing suffix of its schema placeholder.
 */
export function isAtLogicalEnd(selection: Selection): boolean {
  if (!selection.empty) return false
  return getLogicalEndSuffix(selection.$from) !== undefined
}

function resolveBlockEnd(node: EditorNode, pos: number): ResolvedPos {
  const $pos = node.resolve(pos)
  if ($pos.parent.isTextblock) return node.resolve($pos.end())
  if ($pos.nodeAfter?.isBlock) {
    return node.resolve(pos + $pos.nodeAfter.nodeSize - 1)
  }
  return $pos
}
